"use client";

import { Tabs, TabsList, TabsTrigger } from "@shared/src/components/ui/tabs";

interface TradeSwitchProps {
  onToggle: (value: "buy" | "sell") => void;
  value: "buy" | "sell";
  activeColor?: string;
  disabled?: boolean;
}

export function TradeTypeSwitch({ onToggle, value, activeColor, disabled }: TradeSwitchProps) {
  return (
    <Tabs value={value} onValueChange={newValue => onToggle(newValue as "buy" | "sell")}>
      <TabsList variant="button-contained" activeColor={activeColor}>
        <TabsTrigger variant="button-contained" value="buy" disabled={disabled} activeColor={activeColor}>
          Buy
        </TabsTrigger>
        <TabsTrigger variant="button-contained" value="sell" disabled={disabled} activeColor={activeColor}>
          Sell
        </TabsTrigger>
      </TabsList>
    </Tabs>
  );
}
